import { render, staticRenderFns } from "./PlatformStep.vue?vue&type=template&id=0cbc2fb3&scoped=true&"
import script from "./PlatformStep.vue?vue&type=script&lang=js&"
export * from "./PlatformStep.vue?vue&type=script&lang=js&"
import style0 from "./PlatformStep.vue?vue&type=style&index=0&id=0cbc2fb3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cbc2fb3",
  null
  
)

export default component.exports